import React from 'react';
import Navbar from '../components/Navbar';
import QuoteBox from "../components/QuoteBox";
import { PRESS_REVIEWS } from '../data/reviews';

const CAROUSEL_DOT_INDICES = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18"];

export default class Press extends React.Component {
    render() {
        return (
          <div className="dark-background d-flex justify-content-center align-items-center" style={{minHeight: '90vh', paddingBottom: '60px'}}>
                <div className="container">
                    <div className="row justify-content-center page-title-wrapper" style={{marginBottom: '25px'}}>
                        <div className="col-md-3 col-sm-10" style={{textAlign: 'center', maxWidth: '250px', minWidth: '200px'}}>
                            <h1 className="font-satisfy font-peach page-title">Press</h1>
                            <hr className="flaired-edge-separator"/>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-10 newspapers-box">
                            <div className="row justify-content-center align-items-center" style={{height: '100%'}}>
                            <div id="pressCarousel" className="carousel slide carousel-fade" data-ride="carousel" data-interval="6000">
                                <ol className="carousel-indicators">
                                    <li data-target="#pressCarousel" data-slide-to="0" className="active round-indicator" />
                                    {CAROUSEL_DOT_INDICES.map(index => (
                                        <li data-target="#pressCarousel" data-slide-to={index} />
                                    ))}
                                </ol>

                                <div className="carousel-inner">
                                    {PRESS_REVIEWS.map((rev, index) => {
                                        if (index == 0) {
                                            return (
                                                <div className="carousel-item active">
                                                    <QuoteBox
                                                        reviewTitle={rev?.title}
                                                        reviewSubtitle={rev?.subtitle}
                                                        reviewSource={rev?.source}
                                                        reviewText={rev?.text} 
                                                    />
                                                </div>
                                            );
                                        }
                                        return (
                                            <div className="carousel-item">
                                                <QuoteBox
                                                    reviewTitle={rev?.title}
                                                    reviewSubtitle={rev?.subtitle}
                                                    reviewSource={rev?.source}
                                                    reviewText={rev?.text} 
                                                />
                                            </div>
                                        )
                                    })}
                                </div>

                                <a className="carousel-control-prev" href="#pressCarousel" role="button" data-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"/>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className="carousel-control-next" href="#pressCarousel" role="button" data-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"/>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                <Navbar links={[
                    { text: 'Home', reference: '/home' },
                    { text: 'Resume', reference: '/resume' },
                    { text: 'Gallery', reference: '/gallery' },
                    { text: 'Voice', reference: '/voice' },
                    { text: 'Press', reference: '/press', extraClasses: 'active-link' },
                    { text: 'Contact', reference: '/contact' }
                ]}/>
            </div>
        );
    }
}